module.exports = __webpack_public_path__ + "static/media/valuechainanalyses.3994f879.pdf";